import { Params } from '@angular/router';
import { createAction, props } from '@ngrx/store';

export const NavigateTo = createAction(
  '[Router] Navigate to Route',
  props<{ route: 'Home' | 'Cart' | 'Checkout' | 'Login', queryParams?: Params }>()
);
